import { FlagIcon } from 'ui/flags';
import { WebLink2 } from 'ui/theme';
import {
  DATE_FORMAT,
  DATE_FORMAT_WITH_COMMA_HOUR_MINS,
  displayDate,
  displayDateWithDayWeekMonthYearPrefix,
  stripTimezonePrefix,
} from 'utils/date';
import { SecondaryCaption } from './components/styles';

export const getFlagIcon = (region: string) => <FlagIcon code={region || 'default'} height={14} />;

export const getCharacterCountText = (message: string | null) =>
  message?.length ? <SecondaryCaption>{message.length} characters</SecondaryCaption> : null;

export const getDateTime = (timestamp: string) => {
  const isUnixTimestamp = typeof timestamp === 'string' && Number.isInteger(timestamp);
  const timeMillis = isUnixTimestamp
    ? Number(timestamp) * 1000
    : new Date(stripTimezonePrefix(timestamp)).getTime();
  return new Date(timeMillis);
};

export const getDateTimeText = (timestamp: string, withPrefix = true, withTime = true) => {
  const dateTime = getDateTime(timestamp);
  const displayDateTime = withPrefix
    ? displayDateWithDayWeekMonthYearPrefix(dateTime, withTime)
    : displayDate(dateTime, withTime ? DATE_FORMAT_WITH_COMMA_HOUR_MINS : DATE_FORMAT);

  return displayDateTime;
};

export const getFormattedDateTimeText = (timestamp: string, format: string) =>
  displayDate(getDateTime(timestamp), format);

export const addLinkStyling = (text: string | null): string | JSX.Element => {
  if (!text) return '';

  const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
  if (!text.match(urlRegex)) return text;

  const markedText = text.replace(urlRegex, (url) => `#${url}#`);
  const splitText = markedText.split(/#([^\s]+)#/);

  return splitText.reduce(
    (styledText, textPart) => {
      if (!textPart) return styledText;

      if (textPart.match(urlRegex)) {
        return (
          <span>
            <span>{styledText}</span>
            <WebLink2 style={{ cursor: 'default', overflowWrap: 'anywhere' }}>{textPart}</WebLink2>
          </span>
        );
      } else {
        return (
          <span>
            <span>{styledText}</span>
            <span>{textPart}</span>
          </span>
        );
      }
    },
    <></>,
  );
};

export const isUnitedStatesOrCanada = (regionCode: string) =>
  regionCode === 'US' || regionCode === 'CA';
